import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../models/user.model';
import { TeamMember } from '../../models/team.model';
import { NgClass } from '@angular/common';

@Component({
  selector: 'frmg-user-logo',
  templateUrl: './user-logo.component.html',
  styleUrls: ['./user-logo.component.scss'],
  imports: [NgClass]
})
export class UserLogoComponent implements OnInit {
  @Input() user: User | TeamMember;
  @Input() empty: boolean = false;

  public initials: string;

  constructor() {
  }

  ngOnInit(): void {
    let firstName = (this.user as any)?.first_name as string | undefined;
    let lastName = (this.user as any)?.last_name as string | undefined;
    if (this.user.full_name) {
      firstName = this.user.full_name.split(' ')[0];
      lastName = this.user.full_name.split(' ')[1];
    }
    if (firstName || lastName) {
      const f = firstName ? firstName.charAt(0) : '';
      const l = lastName ? lastName.charAt(0) : '';
      this.initials = `${f}${l}` || this.user.email.charAt(0);
    } else {
      this.initials = this.user.email?.charAt(0);
    }
    if (this.initials === '+') this.initials += this.user.email.charAt(1);
  }
}
